import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    signedIn: false,
    primaryRole: "",
    userId: null,
    email: null,
  },
  reducers: {
    login: (state, action) => {
      state.signedIn = true;
      state.userId = action.payload.userId; // Ensure this is a string
      state.email = action.payload?.email;   // Ensure this is a string
    },
    primaryRole: (state, action) => {
      state.primaryRole = action.payload;
    },
    signOut: (state) => {
      state.signedIn = false;
      state.userId = null;
      state.email = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { login, signOut, primaryRole } = userSlice.actions;

export default userSlice.reducer;